import React from "react";

const WelcomeContainer = () => {
  return (
    <>
      <div className="flex flex-col gap-5 w-[694px] px-2">
        <div className="flex flex-col gap-4">
          <h1 className="text-[28px] font-semibold border-b-[1px] border-gray-400">
            Welcome to CSSE
          </h1>
          <p className="text-[15px] font-medium">
            Council for secondary and senior secondary education managed by The
            Council of Basic and Technical Education, which was previously
            established vide Act XXI of 1860 for vocational and educational
            society for the poor and Disadvantaged group as as street children,
            working children, rural women and physically challenged. It has been
            constituted to regulate non formal Primary, Middle, Matriculation
            (10th), Senior Secondary (12th) education and other vocational
            courses (Under Self Employment Education Scheme) in India. Like all
            educational boards/Universities ours is also an autonomous body.
            Each educational organization acts on its own discretionary powers.
            According to these powers every board / university / state Govts. /
            Central Govt. of India has the liberty and right to take its own
            decision either to allow or refuse any admission / service. All the
            education programme run by the board are own autonomous education
            programme. Legality, Validity, Utility of the education programme
            are in strict conformity with the constitution of India and law of
            the land under Article 19(1)G, 29 & 30.
          </p>
        </div>
      </div>
    </>
  );
};

export default WelcomeContainer;
